/* Publish by EComposer at 2026-11-05 00:11:33*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1fv9jtxha70j"]=  window.__ectimmers["ecom-1fv9jtxha70j"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-1fv9jtxha70j').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1fv9jtxha70j', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1fv9jtxha70j', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gwuxhzqea4u').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gwuxhzqea4u', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gwuxhzqea4u', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}